import './FullStatus.css';

import React from 'react';
import FieldComponent from '../../../b2b-common/FieldComponent';
import { generateClassName } from '../../../b2b-common/helpers';
import { calculateTimeProgress, StatusIcon, TrendIcon } from '../helper';
import ProgressFactory from '../progress/ProgressFactory';
import { Box } from '@mui/material';

export const FullStatusComponent = ({ status, trend, progress, startDate, endDate, className = null }) => {
    return (
        <Box className={generateClassName('element-full-status', '', className)} width='100%' display='flex' justifyContent='space-between'>
            <StatusIcon status={status} withTooltip={true} />
            <TrendIcon trend={trend} withTooltip={true} />
            <ProgressFactory progressApproach='SIMPLE' targetProgress={progress}
                timeProgress={calculateTimeProgress(startDate, endDate)} />
        </Box>
    );
};

const FullStatus = ({label, status, trend, progress, startDate, endDate, className = null}) => {
   return (
        <FieldComponent
            label={label}
            component={
                <FullStatusComponent status={status} trend={trend} progress={progress} startDate={startDate} endDate={endDate} />
            }
            className={generateClassName('plan-full-status', '', className)}
            labelAlign='left'
            componentAlign='left'
        />
    );
};

export default FullStatus;